import PicklistMetadata from "../PicklistMetadata";

// Work Groups the current user is a member of (display = Name, value = USID). Sourced client-side from
// SessionContext.getAccount().WorkGroups (login-payload list, filtered server-side to the user's own
// memberships). Used for PRIMARY Work Group (stewardship owner) pickers. The realm-wide "all work
// groups" list used by the Add-Shared-Work-Group picker is a separate picklist ("WorkGroupShared").
class WorkGroupPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "WorkGroup";
        this.static = true;
        this.companySource = "WorkGroups";
        this.useRealm = false;
        this.typeField = "Name";
        this.typeValue = "USID";
        this.allowNoSelection = false;
    }
}

export default WorkGroupPicklistMetadata;
